import type { TableCellPreviewFragment } from "../client/generated";
import { useProtectedImageSource } from "../client/images";
import { CSS_IN_TO_PX } from "../editor/utils";

type Props = {
  fragment: TableCellPreviewFragment;
  topInPx: number;
  leftInPx: number;
  widthInPx: number;
  heightInPx: number;
};

export function TableCellPreview({
  fragment,
  topInPx,
  leftInPx,
  widthInPx,
  heightInPx,
}: Props) {
  const svgSrc = useProtectedImageSource(fragment.svgUrl);

  return (
    <svg
      style={{ width: widthInPx, height: heightInPx }}
      viewBox={`${leftInPx} ${topInPx} ${widthInPx} ${heightInPx}`}
      preserveAspectRatio="none"
    >
      <image
        xlinkHref={svgSrc}
        width={fragment.width * CSS_IN_TO_PX}
        height={fragment.height * CSS_IN_TO_PX}
      />
    </svg>
  );
}
